import React, { useState } from 'react';
import Header from 'components/JourneyViewer/Header';
import { useParams } from 'react-router-dom';
import { TabbedView, TabList, Tab } from 'components/shared/TabbedView';
import { useDispatch, useSelector } from 'react-redux';
import ContentsList from 'components/JourneyViewer/ContentsList';
import { useFeatureFlags, useSessionStorage } from 'hooks';
import classNames from 'classnames';
import { routes as ROUTES } from 'constants/config';
import request from 'utils/request_ajax';
import { displayBanner } from '../../actions/journeyBuilder';
import * as actions from '../../actions/journeyBuilder';
import JourneyBanner from '../JourneyBuilder/Banner/JourneyBanner';
import TopbarOverview from './TopbarOverview';
import InformationSidebar from '../JourneyBuilder/InformationSidebar/InformationSidebar';
import PublishConfirmationModal from './PublishConfirmationModal';

const JourneyOverview = props => {
  const isIframedInSeismic = useSessionStorage('iframedInSeismic');
  const hasUnificationFeatureFlag = useFeatureFlags(
    'readiness-enable-unification',
  );

  const dispatch = useDispatch();

  const { showBanner } = useSelector(state => state.ui);

  const { journeyId } = useParams();

  const { message, status, published } = useSelector(state => state);
  const [showPublishUpdatesModal, setShowPublishUpdatesModal] = useState(false);
  const handleToggle = index => {
    if (index === 0) {
      window.location.assign(`/journey/${journeyId}/reporting`);
    }
  };

  const handlePublishUpdates = () => {
    setShowPublishUpdatesModal(true);
  };

  const overviewClassName = classNames('JourneyOverview', {
    'JourneyOverview--showBanner': showBanner,
    'JourneyOverview--iFrame': isIframedInSeismic && hasUnificationFeatureFlag,
  });

  const handlePublish = () => {
    request
      .patchJSON(ROUTES.JOURNEY.PUBLISH_JOURNEY(journeyId))
      .then(response => {
        window.location.reload();
        // need to reload page to load in all step information (title, description, etc.)
        // until we have a serializer for this flow this is a bandaid fix
      })
      .fail(() => {
        dispatch(
          actions.updateBanner({
            message: t('journeys.builder.request_error'),
            status: 'error',
          }),
        );
        dispatch(displayBanner());
        setShowPublishUpdatesModal(false);
      });
  };

  return (
    <div>
      {showBanner && <JourneyBanner message={message} state={status} />}
      {showPublishUpdatesModal && (
        <PublishConfirmationModal
          show={showPublishUpdatesModal}
          handlePublish={handlePublish}
          hideModal={() => setShowPublishUpdatesModal(false)}
        />
      )}
      <div className={overviewClassName}>
        <TopbarOverview
          handlePublish={handlePublish}
          handlePublishUpdates={handlePublishUpdates}
        />

        <div
          className={classNames('JourneyOverview-flexContainer', {
            'JourneyOverview-flexContainer--showModal': showPublishUpdatesModal,
          })}
        >
          {published && (
            <div className="JourneyBuilder-tabs">
              <TabbedView
                onSelect={index => handleToggle(index)}
                selectedIndex={1}
              >
                <TabList>
                  <Tab>{t('journeys.reporting.reporting')}</Tab>
                  <Tab>{t('journeys.reporting.steps')}</Tab>
                </TabList>
              </TabbedView>
            </div>
          )}

          <div
            className="JourneyBuilder-main"
            style={published ? { marginTop: 82 } : { marginTop: 22 }}
          >
            <div className="JourneyBuilder-previewContainer">
              <div className="JourneyBuilder-content">
                <Header />
                <ContentsList />
              </div>
              <div className="JourneyBuilder-information">
                <InformationSidebar />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JourneyOverview;
